<template>
  <section class="block mx-auto mt-32 max-w-448">
    <SitterAlertBanner v-if="serverError" :error="serverError" />
    <PoppinsCard>
      <h1 class="text-h4 text-m3 pb-12 leading-8">Add your legal address</h1>
      <h3 class="text-grey-text-subdued leading-6 mb-24">
        This is used for Trust and Safety purposes and will not be visible on your profile
      </h3>
      <form id="sitter-address" novalidate @submit.prevent="handleSubmit">
        <AddressAutoComplete
          ref="addressAutoComplete"
          :storedAddress="form"
          :requiredFields="requiredFields"
          @update:modelValue="handleAddress"
        />
        <PoppinsSpinner v-if="showLoader" class="m-auto" />
        <PoppinsButton
          id="formSubmit"
          :loading="false"
          class="w-full my-8"
          variant="primary"
          value="Continue"
          size="medium"
          type="submit"
        />
      </form>
    </PoppinsCard>
  </section>
</template>

<script lang="ts">
import { mapGetters, mapActions } from 'vuex';
import { UPDATE_ADDRESS } from '@/graphql/account/mutations';
import { UPSERT_EMPTY_PROFILE_SITTER } from '@/graphql/profile/mutations';
import AddressAutoComplete from '@/components/addressAutoComplete/AddressAutoComplete.vue';
import SitterAlertBanner from '../account/components/SitterAlertBanner.vue';
import Card from '@/components/card/Card.vue';
import Spinner from '@/components/spinner/Spinner.vue';
import Button from '@/components/button/Button.vue';
import { sendSegmentEvent } from '@/lib/segment';
import { readDomainCookie } from '@/lib/domain_cookie';

export default {
  name: 'SitterAddress',
  components: {
    SitterAlertBanner,
    AddressAutoComplete,
    PoppinsCard: Card,
    PoppinsSpinner: Spinner,
    PoppinsButton: Button,
  },
  data(): any {
    return {
      requiredFields: ['addressLine1', 'city', 'stateCode', 'postalCode'],
      showLoader: false,
      serverError: null,
    };
  },
  computed: {
    ...mapGetters({ form: 'address' }),
  },
  methods: {
    ...mapActions({
      updateAddress: 'updateAddress',
    }),
    handleAddress(addressAutoCompleteFields) {
      Object.keys(this.form).forEach((key) => {
        this.updateAddress({ key, value: addressAutoCompleteFields[key] });
      });
    },
    async handleSubmit() {
      if (this.$refs.addressAutoComplete.validateAll()) {
        this.showLoader = true;
        await this.updateSitterAddress();
      }
    },
    async handleRedirect() {
      if (readDomainCookie('skipProfileCreate') === 'true') {
        this.loading = true;
        try {
          await this.$apollo.mutate({
            mutation: UPSERT_EMPTY_PROFILE_SITTER,
          });
          window.location.href = '/sitter/verify_identity';
          return;
        } catch (error) {
          // Swallow profile upsert errors but we'll send the sitter through the normal profile creation flow
          console.error(error);
        }
      }
      this.$router.push({ path: '/sitter/signup/profile/intro' });
    },
    async updateSitterAddress() {
      try {
        await this.$apollo.mutate({
          mutation: UPDATE_ADDRESS,
          variables: {
            address: this.form,
          },
        });

        sendSegmentEvent('Address Captured', {
          address: this.$store.getters.address.addressLine1,
          address2: this.$store.getters.address.addressLine2,
          city: this.$store.getters.address.city,
          state: this.$store.getters.address.stateCode,
          zip: this.$store.getters.address.postalCode,
        });

        this.handleRedirect();
      } catch (error) {
        console.error(error);
        this.serverError = new Error('unknown-error');
      }
    },
  },
};
</script>
